import {getToken, logout} from "../helpers/token";

export default class _Request {
    constructor(path, api = '/api/') {
        this.path = api + path;
    }

    static isOkStatus(status) {
        return [200, 201, 204].includes(status);
    }

    static makeQuery(obj) {
        let query = '';
        Object.keys(obj).forEach((key) => {
            query += `&${key}=${obj[key]}`
        });
        return query;
    }

    static _handleErrors(res) {
        if (res.status === 401) {
            logout();
        }
        //logout
        return res;
    }

    send(req, errHandler) {
        const path = `${this.path}${req.path}`;
        return _Request._makeRequest(req, path, errHandler).then((res) => {
            return res;
        })
    }

    sendPdf(req, errHandler) {
        return _Request._makePdfRequest(req, `/api${req.path}`, errHandler).then((res) => {
            return res;
        })
    }

    static _makePdfRequest(req, path, errHandler) {
        return _Request.fetcher(req, path, errHandler)
            .then((res) => _Request._handleErrors(res))
            .then((res) => {
                    if (!this.isOkStatus(res.status)) {
                        if (errHandler) {
                            return errHandler(res);
                        }
                    }

                    return res;
                }
            )
            .catch(error => {
                if (errHandler) {
                    return errHandler();
                }
                return {status: error.message, json: {}}
            });
    }

    static _makeRequest(req, path, errHandler) {
        return _Request.fetcher(req, path, errHandler)
            .then((res) => _Request._handleErrors(res))
            .then((res) => {
                    if (!this.isOkStatus(res.status)) {
                        if (errHandler) {
                            return errHandler(res);
                        }
                    }
                    return res.json().then(json => {
                        return {status: res.status, json};
                    });
                }
            )
            .catch(error => {
                if (errHandler) {
                    return errHandler();
                }
                return {status: error.message, json: {}}
            });
    }

    static fetcher(req, path) {
        const headersObj = Object.assign({
            'content-type': 'application/json',
            'Cache-Control': 'no-cache',
            'Authorization': `Bearer ${getToken()}`
        }, req.headers);

        const headers = new Headers(headersObj);

        const options = Object.assign({
            method: 'POST',
        }, req.options);

        options.headers = headers;
        const request = new Request(path, options);
        return fetch(request)
    }

    static timeoutPromise(data) {
        return new Promise((res) => {
            setTimeout(() => res(data), 300)
        })
    }

    static fakeSearchEndpoint(options, dataCreator) {
        const {current, pageSize} = options.pagination;

        return _Request.timeoutePromise(
            {
                list: Array(40).fill().map(dataCreator)
                    .sort((a, b) => {
                        const d = options.sort.order === 'ascend' ? 1 : -1;
                        if (a[options.sort[0]] < b[options.sort[0]]) {
                            return d
                        }
                        if (a[options.sort.field] > b[options.sort.field]) {
                            return -1 * d
                        }
                        return 0;
                    }).map(row => ({...row, key: row.id}))
                    .splice((current - 1) * pageSize, pageSize)
            })
    }

}